// New Reg's price list, written into the page by index.plate as window.NR_PRICES (the old
// site's libs/configuration/price_list.php, i.e. the engine's search/prices.json). Every
// amount includes VAT. Each default is the price this checkout used before the list existed,
// and is used when the page has no list or the list has no such figure.

type PriceList = { [key: string]: any };

const list: PriceList = (typeof window !== "undefined" && (window as any).NR_PRICES) || {};

function pick(path: string, fallback: number): number {
  let v: any = list;
  for (const key of path.split(".")) {
    if (v === null || typeof v !== "object" || !(key in v)) return fallback;
    v = v[key];
  }
  if (v !== null && typeof v === "object") v = v.inc_vat;
  const n = typeof v === "number" ? v : parseFloat(v);
  return Number.isFinite(n) ? n : fallback;
}

export const PRICES = {
  platesPair: pick("plates.pair", 31.14),
  platesSingle: pick("plates.single", 14.5),
  transferService: pick("services.transfer_service", 29.4),
  giftWrap: pick("services.gift_wrap", 7.14),
  deliveryStandard: pick("delivery.standard", 10.74),
  deliveryRecorded: pick("delivery.recorded", 13.14),
  deliverySpecial: pick("delivery.special", 16.74),
};
